import LayoutBasic from '../layouts/layoutBasic'
import { withRouter } from 'next/router'
import {GET} from '../helpers'
import {TOKEN, GET_USER_URL, CART} from '../vars'
import {setLocalKeyValue, getLocalKeyValue} from '../storage'
class AboutUs extends React.Component  {


    static async getInitialProps(props) {
      let token =  await process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token

      let infoRequest, infoResponse={}
      if(token) {
        try {
          infoRequest = await GET(GET_USER_URL, token)
          infoResponse = await infoRequest.data
        } catch (e) {

        }
      }

      return {
        token: token,
        user: infoResponse.user,
        cart: infoResponse.cart,
      }
    }

  render() {

    return <LayoutBasic title="About Picxy" {...this.props}>
      <div className="container font-small my-5">
        <div className="row">
          <div className="col-sm-12">

          <h1 className="title mb-4">About Us</h1>

          <h2>Who We Are</h2>
          <p>Picxy is a technology-driven photography and visual content platform based in Visakhapatnam, Andhra Pradesh, India. We connect clients with professional photographers, videographers, and reel creators to deliver high-quality event coverage, intelligent photo management, and instant edited content — all through a single, streamlined platform.</p>

          <h2>Our Journey</h2>
          <p>Picxy began as a platform offering royalty-free stock image licensing alongside photography services. As the needs of our clients evolved, we made the strategic decision to focus exclusively on event-based and personalized visual services — where we believe we can deliver the most value. Today, our offerings are built entirely around helping clients capture, manage, and share moments from their own events.</p>

          <h2>What We Do</h2>
          <p>We currently offer three core services:</p>

          <h3 className='ms-4'>Photography &amp; Videography Booking</h3>
          <p  className='ms-4'>Book professional, vetted photographers and videographers for weddings, corporate events, celebrations, and more — with transparent pricing and reliable delivery timelines.</p>

          <h3 className='ms-4'>AI Face Sync</h3>
          <p className='ms-4'>Our proprietary facial recognition technology automatically matches and organizes event photographs and videos for each attendee, making it effortless for guests to find and access their own pictures from large events.</p>

          <h3 className='ms-4'>Instashot</h3>
          <p  className='ms-4'>Get professionally edited, ready-to-share reels delivered instantly after your event — tailored to your brief, with revisions based on your feedback.</p>

          <h2>Our Contributors</h2>
          <p>Behind every shoot is a network of skilled photographers, videographers, and reel editors — our Contributors — who bring their craft and local expertise to every booking made through Picxy. We're committed to fair, timely payouts and long-term partnerships with the creative professionals on our platform.</p>

          <h2>Our Commitment</h2>
          <p>We aim to make professional photography and videography services accessible, reliable, and technology-enabled — from the moment you book, to the moment you receive your final content.</p>

          <h2>Get in Touch</h2>
          <p>Have questions about our services? Reach out to us at <a href="mailto:support@picxy.com">support@picxy.com</a> or <a href="tel:+918885558235">+91 8885558235</a>.</p>
          </div>
        </div>
      </div>
    </LayoutBasic>
    }

}

export default withRouter(AboutUs)
